import { useTranslation } from 'react-i18next'

import Section from '../components/Section'

interface TextSection {
  heading: string
  body: string[]
}

// Straightforward "heading + paragraphs" blocks, in document order. The
// operator-info block (1.) is rendered separately below since it's a
// labelled list, not prose.
const BODY_KEYS = [
  'purpose',
  'ip',
  'accuracy',
  'liability',
  'links',
  'law',
  'changes',
  'contact',
] as const

function TermsPage() {
  const { t } = useTranslation()
  const operator = t('legal.terms.operator', { returnObjects: true }) as Record<
    string,
    string
  >

  const sections: TextSection[] = BODY_KEYS.map((key) => ({
    heading: t(`legal.terms.${key}Heading`),
    body: t(`legal.terms.${key}Body`, { returnObjects: true }) as string[],
  }))

  return (
    <div className="legal-page">
      <Section background="surface" space="md" className="legal-hero">
        <h1 className="display">{t('legal.terms.title')}</h1>
        <p className="legal-updated">
          {t('legal.updatedLabel', { date: t('legal.lastUpdated') })}
        </p>
        <p className="legal-lead">{t('legal.terms.intro')}</p>
      </Section>

      <Section background="beige" space="lg" className="legal-body">
        <article className="legal-article">
          <h2>{t('legal.terms.operatorHeading')}</h2>
          <p>{t('legal.terms.operatorIntro')}</p>
          <ul className="legal-operator">
            <li>{operator.name}</li>
            <li>{operator.form}</li>
            <li>{operator.operatedBy}</li>
            <li>{operator.address}</li>
            <li>{operator.vat}</li>
            <li>{operator.email}</li>
            <li>{operator.phone}</li>
          </ul>

          {sections.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.body.map((para) => (
                <p key={para}>{para}</p>
              ))}
            </section>
          ))}
        </article>
      </Section>
    </div>
  )
}

export default TermsPage
